import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PeerDmModal from './peer_dm_modal';
import mayStartConversations from '../my_inbox/mayStartConversations';

// Button + PeerDmModal pair for server-rendered surfaces (e.g. the PR-user profile
// show_card partial). The grid-card JSX (pr_user_card.jsx, reporter_card.jsx) inlines
// the same pattern; this wrapper exists so ERB can mount it via react_component.
function PeerDmComposeButton({
  peerUserId, peerFirstName, peerName, peerTitle, peerAvatarUrl, peerInitials,
}) {
  const [open, setOpen] = useState(false);
  if (!mayStartConversations()) return null;

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-primary"
        onClick={() => setOpen(true)}
      >
        <i className="float-left fa fa-paper-plane text-white" />
        <span className="ms-2">Message {peerFirstName}</span>
      </button>
      <PeerDmModal
        isOpen={open}
        onClose={() => setOpen(false)}
        peerUserId={peerUserId}
        peerFirstName={peerFirstName}
        peerName={peerName}
        peerTitle={peerTitle}
        peerAvatarUrl={peerAvatarUrl}
        peerInitials={peerInitials}
      />
    </>
  );
}

PeerDmComposeButton.propTypes = {
  peerUserId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  peerFirstName: PropTypes.string,
  peerName: PropTypes.string,
  peerTitle: PropTypes.string,
  peerAvatarUrl: PropTypes.string,
  peerInitials: PropTypes.string,
};

PeerDmComposeButton.defaultProps = {
  peerFirstName: 'them',
  peerName: undefined,
  peerTitle: undefined,
  peerAvatarUrl: undefined,
  peerInitials: undefined,
};

export default PeerDmComposeButton;
